"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var js_synchronisation_1 = require("../js-synchronisation");
var preload_1 = require("../preload");
var js_signOperation_1 = __importDefault(require("../js-signOperation"));
var js_getTransactionStatus_1 = __importDefault(require("../js-getTransactionStatus"));
var js_broadcast_1 = __importDefault(require("../js-broadcast"));
var js_estimateMaxSpendable_1 = __importDefault(require("../js-estimateMaxSpendable"));
var js_prepareTransaction_1 = __importDefault(require("../js-prepareTransaction"));
var js_createTransaction_1 = __importDefault(require("../js-createTransaction"));
var updateTransaction = function (t, patch) { return (__assign(__assign({}, t), patch)); };
var receive = (0, jsHelpers_1.makeAccountBridgeReceive)();
var currencyBridge = {
    getPreloadStrategy: preload_1.getPreloadStrategy,
    preload: preload_1.preload,
    hydrate: preload_1.hydrate,
    scanAccounts: js_synchronisation_1.scanAccounts
};
var accountBridge = {
    estimateMaxSpendable: js_estimateMaxSpendable_1["default"],
    createTransaction: js_createTransaction_1["default"],
    updateTransaction: updateTransaction,
    getTransactionStatus: js_getTransactionStatus_1["default"],
    prepareTransaction: js_prepareTransaction_1["default"],
    sync: js_synchronisation_1.sync,
    receive: receive,
    signOperation: js_signOperation_1["default"],
    broadcast: js_broadcast_1["default"]
};
exports["default"] = {
    currencyBridge: currencyBridge,
    accountBridge: accountBridge
};
//# sourceMappingURL=js.js.map